"use client";

import React from "react";
import UserLineIcon from "remixicon-react/UserLineIcon";
import MailLineIcon from "remixicon-react/MailLineIcon";
import PhoneLineIcon from "remixicon-react/PhoneLineIcon";
import MapPinLineIcon from "remixicon-react/MapPinLineIcon";

import { CompanyUser } from "@/types/user";

interface ContactInfoProps {
  user: CompanyUser | null;
}

const ContactInfo: React.FC<ContactInfoProps> = ({ user }) => (
  <div className="bg-white rounded-3xl overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300">
    {/* Header */}
    <div className="bg-primary p-8 flex flex-col items-center">
      <div className="bg-white p-1 rounded-full mb-3 shadow-lg">
        <div className="w-24 h-24 rounded-full border-2 border-white flex items-center justify-center bg-white text-primary overflow-hidden">
          {user?.image ? (
            <img
              src={user.image}
              alt="Profile"
              className="w-full h-full object-cover"
            />
          ) : (
            <UserLineIcon size={64} />
          )}
        </div>
      </div>
      <h2 className="text-white text-xl font-bold">
        {user?.firstName} {user?.lastName}
      </h2>
      <p className="text-white/90">{user?.email}</p>
    </div>
    {/* Contact Info */}
    <div className="p-6">
      <h3 className="text-gray-400 font-bold text-xs uppercase mb-6 tracking-wide">
        Contact Information
      </h3>
      <div className="space-y-6">
        <div className="flex gap-4">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary shrink-0">
            <MailLineIcon size={20} />
          </div>
          <div className="overflow-hidden">
            <p className="text-gray-400 text-sm">Email</p>
            <p className="font-medium text-black truncate">{user?.email}</p>
          </div>
        </div>
        <div className="flex gap-4">
          <div
            className={`w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center ${user?.contactNo ? "text-primary" : "text-gray-400"} shrink-0`}
          >
            <PhoneLineIcon size={20} />
          </div>
          <div>
            <p className="text-gray-400 text-sm">Phone</p>
            <p
              className={`font-medium ${user?.contactNo ? "text-black" : "text-gray-400"}`}
            >
              {user?.contactNo || "Not provided"}
            </p>
          </div>
        </div>
        <div className="flex gap-4">
          <div
            className={`w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center ${user?.role === "companyAdmin" ? (user?.company?.streetAddress ? "text-primary" : "text-gray-400") : user?.store?.streetAddress ? "text-primary" : "text-gray-400"} shrink-0`}
          >
            <MapPinLineIcon size={20} />
          </div>
          <div>
            <p className="text-gray-400 text-sm">Address</p>
            <p
              className={`font-medium ${user?.role === "companyAdmin" ? (user?.company?.streetAddress ? "text-black" : "text-gray-400") : user?.store?.streetAddress ? "text-black" : "text-gray-400"}`}
            >
              {user?.role === "companyAdmin"
                ? user?.company?.streetAddress
                : user?.store?.streetAddress || "Not Provided"}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ContactInfo;
